import { render, staticRenderFns } from "./GiftTransferAdjustForm.vue?vue&type=template&id=6aea687a&"
import script from "./GiftTransferAdjustForm.vue?vue&type=script&lang=js&"
export * from "./GiftTransferAdjustForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports